const NAVBAR_LOCALSTORAGE_KEY = 'navbarStatus';

export function getStoredNavbarStatus() 
{
  if (typeof window !== 'undefined') {
    const storedNavbarStatus = localStorage.getItem(NAVBAR_LOCALSTORAGE_KEY) || false;
    return storedNavbarStatus ? JSON.parse(storedNavbarStatus) : null;
  }
}

export function setStoredNavbarStatus(navBarItemList) {
  if (typeof window !== 'undefined') {
    localStorage.setItem(NAVBAR_LOCALSTORAGE_KEY, JSON.stringify(navBarItemList)) || false;
  }
}

export function clearStoredNavbarStatus() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(NAVBAR_LOCALSTORAGE_KEY) || false;
  }
}
